<template>
<div>
    <template v-if="!loading">
        <h1>{{ $lang("大眾單車遊")}}</h1>
        <div class="dashed">
            <div class="summer-attention" v-if="cyclingParade.content">
                <div v-html="cyclingParade.content"></div>
            </div>
            <div v-if="isEnroll">
                <template v-if="isEnroll">
                    <p>
                        <span>{{ $lang("TEXT_VIEW_INFORMATION") }}</span>
                    </p>
                    <ul>
                        <template v-for="item in records">
                            <li v-if="item.status != 'draft'" :key="item.id">
                                <span></span>
                                <router-link class="submitForm" :to="`public-challenge-game/perview/${item.id}`">{{ item.title }}</router-link>
                            </li>
                            <li v-else :key="item.id">
                                <span>{{ item.title }}</span>
                                <router-link class="btn btn-primary" :to="`public-challenge-game/edit/${item.id}`">{{ $lang("修改") }}</router-link>
                                <b-btn variant="info" @click="handlerDelete(item.id)">{{$lang("刪除")}}</b-btn>
                                <!-- <b-btn variant="danger" @click="handlerSumbit(item.id)">{{$lang("提交")}}</b-btn> -->
                                <router-link variant="info" class="btn btn-danger" :to="`public-challenge-game/edit/${item.id}`">{{ $lang("提交") }}</router-link>
                            </li>
                        </template>
                    </ul>
                </template>
            </div>
            <div v-if="isChange">
                <!-- <p>
                    <router-link to="physical-challenge-game" class="listen-tnc">{{$lang("TEXT_AGREE_CONTENT")}}</router-link>
                </p> -->
                <p v-if="isChange">
                    <span @click="openModel()" class="listen-tnc btn">{{$lang("TEXT_AGREE_CONTENT")}}</span>
                </p>
            </div>
        </div>
    </template>
    <template v-else>
        <div class="spinner">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
    </template>
</div>
</template>

<script>
import {
    $apis
} from "@/helper";
import game from "@/components/game";
import List from "@/components/List";
export default {
    components: {
        game,
        List
    },
    data() {
        return {
            loading: true,
            isReadOnly: true,
            isAgree: false,
            records: [],
            groups: [],
            dynamicGame: {}
        };
    },
    created() {
        this.isLoading();
        this.$store.dispatch("base/getPage");
    },
    methods: {
        async isLoading() {
            this.loading = true;
            await this.getRecordList();
            this.loading = false;
        },
        // 获取报名表记录
        async getRecordList() {
            try {
                let resp = await $apis.public.recordList();
                resp.code === 0 && (this.records = resp.data.records);
            } catch (e) {
                console.log(e);
            }
        },
        // 删除报名表记录
        async deleteRecordDetail(id) {
            try {
                let resp = await $apis.public.deleteRecordDetail({
                    id
                })
                await this.getRecordList();
                // await this.getGroupList();
                if(resp.code == 0) this.notification.success(this.$lang("删除成功"))
                else throw new Error(resp)
            } catch (e) {
                this.notification.error(this.$lang("删除失败"));
                console.log(e);
            }
        },
        // 正式提交表明表记录
        async formalSubmission(id) {
            try {
                let resp = await $apis.dynamic.formalSubmission({
                    id
                });
                await this.getRecordList();
                await this.getGroupList();
                if(resp.code == 0) this.notification.success(this.$lang("提交成功"))
                else throw new Error(resp)
            } catch (e) {
                this.notification.success(this.$lang("提交失败"));
                console.log(e);
            }
        },
        handlerDelete(id) {
            let r = confirm(this.$lang("是否刪除報名表!"));
            if (r == true) {
                this.deleteRecordDetail(id);
            }
        },
        handlerSumbit(id) {
            let r = confirm(this.$lang("是否確認提交!"));
            if (r == true) {
                this.formalSubmission(id);
            }
        },
        // 個人/團隊 同意報名
        openModel() {
            this.$router.push({
                path: "public-challenge-game"
            })
        }
    },
    computed: {
        cyclingParade() {
            return this.$store.state.base.cyclingParade;
        },
        isEnroll() {
            return this.records.length || 0;
        },
        isChange() {
            return this.records.length < 2;
        }
    }
};
</script>
